<template>
    <div id="container-principal">
        <h1 class="fw-normal mt-5 text-center">Listado de mesas</h1>
        <p class="text-center">Nº total de mesas: {{ tables.length }}</p>
        <div class="d-flex justify-content-end mb-3">
            <button class="btn btn-add d-none d-md-block px-5" :class="{ 'btn-disabled': !allowPosts }" @click="showAddTableModal">Añadir</button>
        </div>
        <div v-if="tables.length > 0" class="row m-0 d-flex align-items-center justify-content-center">
            <div class="col-12 col-md-6 col-lg-4 mb-2 table-card " v-for="table in tables" :key="table.id" >
                <div class="card h-100">
                    <div class="d-flex flex-column flex-md-row g-0 ">
                        <div class="col-12 d-flex flex-column p-0 position-relative">
                            <div class="card-actions d-md-none position-absolute" style="top: 0; right: 0;">
                                <i class="fa-solid fa-pencil mr-2 action-icon" style="color: var(--primary-color);" @click="showEditModal(table)"></i>
                                <i class="fa-regular fa-trash-can action-icon" :class="{ 'btn-disabled': !allowPosts }" style="color: var(--primary-color);" @click="(!allowPosts) ? showTPVSyncAlert() : showDeleteModal(table)"></i>
                            </div>
                            <div class="row mt-4 pt-2 d-md-none">
                                <h3 class="table-name" style="font-size: 1.3rem; text-align: center;">{{ table.number }}</h3>
                            </div>
                            <div class="d-flex align-items-center p-0 flex-wrap">
                                <div class="col-6 col-md-4 d-flex">
                                    <img :src="table.image || defaultImageUrl" class="img-fluid" alt="Table Image" />
                                </div>
                                <div class="col-6 col-md-8 d-flex flex-column justify-content-center p-2 mt-2">
                                    <div class="p-0">
                                        <h3 class="table-name d-none text-center d-md-block" style="font-size: 1.5rem;">{{ table.number }}</h3>
                                        <p class="diners-count" style="font-size: 1rem; text-align: center;">Nº de comensales: {{ table.max_diners }}</p>
                                        <p style="font-size: 0.7rem;" class="my-2 table-name text-black fw-normal" @click="copyToClipboard(`https://ewu.es/loginQr/${table.id}`)" v-if="!table.is_delivery && !table.is_take_away">
                                            https://ewu.es/loginQr/{{table.id}}
                                        </p>
                                        <p style="font-size: 0.7rem;" class="my-2 table-name text-black fw-normal" @click="copyToClipboard(`https://ewu.es/Delivery/${table.restaurant.delivery_name}`)" v-else-if="table.is_delivery">
                                            https://ewu.es/Delivery/{{table.restaurant.delivery_name}}
                                        </p>
                                        <p style="font-size: 0.7rem;" class="my-2 table-name text-black fw-normal" @click="copyToClipboard(`https://ewu.es/TakeAway/${table.restaurant.delivery_name}`)" v-else>
                                            https://ewu.es/TakeAway/{{table.restaurant.delivery_name}}
                                        </p>
                                        <p style="font-size: 1rem;" class="my-2 text-center text-success fw-bold" v-if="table.active">Activa</p><p style="font-size: 1rem;" class="my-2 text-center text-danger fw-bold" v-else >Desactiva</p>
                                        <div class="card-actions d-none d-md-block mt-2 d-flex align-items-center justify-content-center">
                                            <i class="fa-solid fa-pencil ml-0 mr-2 action-icon" style="color: var(--primary-color);" @click="showEditModal(table)"></i>
                                            <i class="fa-regular fa-trash-can action-icon" :class="{ 'btn-disabled': !allowPosts }" style="color: var(--primary-color);" @click="(!allowPosts) ? showTPVSyncAlert() : showDeleteModal(table)"></i>
                                        </div>
                                        <div v-if="table.is_delivery" class="position-absolute" style="top:0; left:0;">
                                            <span class="bg-primary rounded-5 px-2">delivery</span>
                                        </div>
                                        <div v-if="table.is_take_away" class="position-absolute" style="top:0; left:0;">
                                            <span class="bg-warning rounded-5 px-2">take away</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <h5 v-else class="text-center mt-5">No hay mesas creadas aún</h5>
        
        <div class="d-flex aling-items-center justify-content-center">
            <button class="btn btn-add w-75 d-md-none mb-3 text-center" @click="showAddTableModal">Añadir</button>
        </div>

        <div v-if="showTPVAlert" class="position-fixed bottom-0 end-0 border shadow-lg rounded mb-3 mr-5 d-none d-md-flex align-items-center w-50" style="z-index: 1000;">
            <div class="bg-white border shadow-lg p-3 rounded w-100">
                <h6 class="mt-2 text-center"><i class="fa-solid fa-circle-exclamation text-warning"></i> La aplicación está sincronizada con el TPV y no se permiten cambios desde la plataforma.</h6>
            </div>
        </div>
        
        <div v-if="showTPVAlert" class="position-fixed top-0 start-0 w-100 h-100 d-md-none d-flex align-items-center justify-content-center" style="z-index: 1000; background-color: rgba(139, 139, 139, 0.5);">
            <div class="bg-white border shadow-lg p-3 rounded w-100 mx-3">
                <h6 class="mt-2 text-center"><i class="fa-solid fa-circle-exclamation text-warning"></i> La aplicación está sincronizada con el TPV y no se permiten cambios desde la plataforma.</h6>
            </div>
        </div>

        <EditTableModalComponent
            :show-modal="showEdit"
            :table="selectedTable"
            :allow-posts="allowPosts"
            @close-modal="closeEditModal"
            @update-table="updateTable"
        />

        <DeleteTableModalComponent
            :show-modal="showDelete"
            :table="selectedTable"
            @close-modal="closeDeleteModal"
            @confirm-delete="confirmDeleteTable"
        />

        <AddTableModalComponent
            :show-modal="showAdd"
            :allow-posts="allowPosts"
            @close-modal="closeAddModal"
            @confirm-add="addTable"
        />
        <SpinnerComponent id="spinner"></SpinnerComponent>
    </div>
</template>

<script>
    import EditTableModalComponent from '../components/EditTableModalComponent.vue';
    import DeleteTableModalComponent from '../components/DeleteTableModalComponent.vue';
    import AddTableModalComponent from '../components/AddTableModalComponent.vue';
    import { mapState } from 'vuex';
    import axios from 'axios';
    import SpinnerComponent from '../components/SpinnerComponent.vue'
    import { v4 as uuidv4 } from 'uuid';


    export default {
        components: {
            EditTableModalComponent,
            DeleteTableModalComponent,
            AddTableModalComponent,
            SpinnerComponent
        },
        data() {
            return {
                tables: [],
                selectedTable: null,
                showEdit: false,
                showDelete: false,
                showAdd: false,
                defaultImageUrl: require('@/assets/imagenMesaPredefinida.jpg'),
                allowPosts: false,
                showTPVAlert: false,
            };
        },
        computed: {
        ...mapState(['partner_token'])
        },
        methods: {
            showEditModal(table) {
                this.selectedTable = { ...table };
                this.showEdit = true;
            },
            closeEditModal() {
                this.showEdit = false;
                this.selectedTable = null;
            },
            showDeleteModal(table) {
                this.selectedTable = { ...table };
                this.showDelete = true;
            },
            closeDeleteModal() {
                this.showDelete = false;
                this.selectedTable = null;
            },
            showAddTableModal() {
                if (!this.allowPosts) {
                    this.showTPVSyncAlert();
                    return;
                }
                this.showAdd = true;
            },
            closeAddModal() {
                this.showAdd = false;
            },
            async addTable(newTable) {
                let table = {
                    id: String(uuidv4()),
                    number: newTable.number,
                    max_diners: newTable.max_diners,
                    available: newTable.available,
                    active: newTable.active
                }
                const url = process.env.VUE_APP_API_URL+'/v1/api/app/tableCreate';
                try {
                    const response = await axios.post(url, table, {
                    headers: {
                        'Authorization': `Bearer ${this.partner_token}`
                    }
                    });
                    console.log(response.data);
                    this.getMesas()
                } catch (error) {
                    console.error('Error fetching shopping cart:', error);
                }
                this.closeAddModal();
            },
            async updateTable(updatedTable) {
                const url = process.env.VUE_APP_API_URL+'/v1/api/app/tableUpdate';
                try {
                    const response = await axios.put(url, updatedTable, {
                    headers: {
                        'Authorization': `Bearer ${this.partner_token}`
                    }
                    });
                    console.log(response.data);
                    this.getMesas()
                } catch (error) {
                    console.error('Error fetching shopping cart:', error);
                }
                this.closeEditModal();                
            },
            async confirmDeleteTable(id) {
                console.log(id)
                const url = process.env.VUE_APP_API_URL+'/v1/api/app/tableDelete?table_id='+id;
                console.log(url)
                try {
                    const response = await axios.delete(url, {
                    headers: {
                        'Authorization': `Bearer ${this.partner_token}`
                    }
                    });
                    console.log(response.data);
                    this.getMesas()
                } catch (error) {
                    console.error('Error fetching shopping cart:', error);
                }
                this.closeDeleteModal();
            },
            async getMesas(){
                const token = this.partner_token; // Suponiendo que tienes el token almacenado en Vuex
                const url = process.env.VUE_APP_API_URL+'/v1/api/app/PanelTables';
                try {
                    const response = await axios.get(url, {
                        headers: {
                        'Authorization': `Bearer ${token}`
                        }
                    });

                    // Maneja la respuesta
                    console.log(response.data);
                    this.tables = response.data.tables;
                    this.tables = this.tables.sort((a, b) => {
                        return a.number.localeCompare(b.number);
                    });
                    document.getElementById("spinner").classList.add("d-none")
                } catch (error) {
                    // Maneja el error
                    this.tables = []
                    document.getElementById("spinner").classList.add("d-none")
                    console.error('Error fetching tables:', error);
                }
            },
            copyToClipboard(url) {
                navigator.clipboard.writeText(url).then(() => {
                    alert(`Se ha copiado el link de la mesa: ${url}`);
                }).catch(err => {
                    console.error('Error al copiar el link: ', err);
                });
            },
            async getAllowPosts() {
                const url = process.env.VUE_APP_API_URL + '/v1/api/app/get_tpv_allow_posts';
                try {
                    const response = await axios.get(url, {
                        headers: {
                            'Authorization': `Bearer ${this.partner_token}`
                        }
                    });
                    this.allowPosts = response.data.allow_posts;
                    console.log("TPV allow_posts:", this.allowPosts);
                } catch (error) {
                    console.error('Error fetching allow_posts:', error);
                }
            },
            showTPVSyncAlert() {
                this.showTPVAlert = true;
                setTimeout(() => {
                    this.showTPVAlert = false;
                }, 3000);
            },
        },
        created() {
            this.getMesas()
            this.getAllowPosts()
        },
    };
</script>

<style scoped>
    .card {
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        padding: 16px;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
    }


    .table-name {
        color: #f57c00;
        font-weight: bold;
        text-align: center;
        overflow: hidden;
        display: -webkit-box;
        height: 2rem;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        line-height: 1.5;
        max-height: calc(1.5em * 2);
        text-overflow: ellipsis;
        word-wrap: break-word;
        word-break: break-word;
    }

    .diners-count {
        margin: 0;
        color: #333;
        font-size: 1.2em;
    }

    .card-actions {
        display: flex;
        align-items: center;
        gap: 3px;
    }

    .action-icon {
        font-size: 2rem;
        color: var(--primary-color);
        cursor: pointer;
    }

    .btn.btn-add {
        background-color: var(--primary-color);
        color: white;
        font-size: 1.25rem;
        border-radius: 8px;
        height: 40px;
        border: none;
        cursor: pointer;
    }

    .btn-disabled {
        opacity: 0.5;
        pointer-events: auto;
        cursor: not-allowed;
    }


    @media (min-width: 768px) {
        .card-actions {
            position: static;
            text-align: center;
        }
        .action-icon {
            margin-inline: 1rem;
        }
        #container-principal{
            margin-left:22%; 
            width: 77%;
        }
    }

    @media (max-width: 576px) {
        .action-icon {
            font-size: 1.3rem;
        }
        #container-principal{
            width: 90%;
            margin: auto;
        }
    }
</style>